import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchBoxApiClient extends AdvancedApiClient {

    static entityType = "FarfetchBox"

    constructor(token, channelId) {
        super();

        this.setEntityType(FarfetchBoxApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/farfetch/box")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}